<template>
  <div class="panel-group" :id="id" role="tablist">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "accordion",
  props: {
    id: {
      type: String,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Collapse/Accordion.vue